import AddUserIcon from './AddUser'
import AddRowIcon from './AddRow'
import ImportFileIcon from './ImportFile'
import UploadIcon from './Upload'
import EditIcon from './Edit'
import CreateEventIcon from './CreateEvent'
import PrevIcon from './Prev'
import NextIcon from './Next'
import ImgPlaceholderIcon from './ImgPlaceholder'

import CheckIcon from './CheckIcon'
export default {
    AddUserIcon,
    AddRowIcon,
    ImportFileIcon,
    UploadIcon,
    EditIcon,
    CreateEventIcon,
    PrevIcon,
    NextIcon,
    ImgPlaceholderIcon,
    CheckIcon
}
